import classNames from "classnames";
import dayjs from "dayjs";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  useInstallationStore,
  useNumberOfDaysStore,
  useGlobalStore,
} from "src/store";
import { numberOfDaysSelection } from "src/utils/constants";
import { FormSchema } from "src/utils/formSchema";
import { FormControl, FormField, FormItem } from "../ui/form";
import { AnimatedSelect } from "../AnimatedSelect/AnimatedSelect";

export type RangePickerSelectedDays = {
  from: string;
  to: string;
};

const daysDropdownValues = numberOfDaysSelection();

type Props = {
  form: UseFormReturn<FormSchema, unknown>;
};

export default function NumberOfDaysSelector({ form }: Props) {
  const { installationDetails } = useInstallationStore();
  const { numberOfDays, setNumberOfDays } = useNumberOfDaysStore();
  const { global } = useGlobalStore();
  const { t } = useTranslation();

  const isCityEmpty = !installationDetails.city;

  const dateRange = form.watch("dateRange");

  return (
    <div>
      <FormField
        name="numberOfDays"
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <AnimatedSelect
                id="numberOfDays"
                options={daysDropdownValues}
                value={numberOfDays}
                isDisabled={isCityEmpty}
                placeholder={t(
                  "installations:inputs:numberOfDays:labelStepOne"
                )}
                onChange={(e: any) => {
                  if (e && dateRange?.from) {
                    const dateTo = dayjs(dateRange.from)
                      .add(+e.value - 1, "day")
                      .format("YYYY-MM-DD");

                    form.setValue("dateRange", {
                      from: dateRange.from,
                      to: dateTo,
                    });
                  }

                  e && setNumberOfDays(e);
                  return field.onChange(
                    e ? { from: dateRange?.from, to: dateRange?.to } : null
                  );
                }}
              />
            </FormControl>
            <p
              className={classNames({
                required: true,
                "display-none": !global.showRequired,
              })}
            ></p>
          </FormItem>
        )}
      />
    </div>
  );
}
